import Store from './StoreHelper';
import extractText from 'flarum/common/utils/extractText';
export default function store(app) {
  Store.addFrontendProviders('exp', app.translator.trans('foskym-custom-levels.lib.integrations.store.item_name'), async function getProviderData(providerDatas, special) {
    providerDatas['same_as_use_cnt'] = extractText(app.translator.trans('foskym-custom-levels.lib.integrations.store.provider_data.same_as_use_cnt'));
  }, function createItemShowCase(item, purchase_history) {
    let expText = app.forum.attribute('foskym-custom-levels.expText') || extractText(app.translator.trans('foskym-custom-levels.lib.defaults.exp'));
    if (expText.indexOf('[expTotal]') > -1) expText = expText.replace('[expTotal]', item?.use_cnt());else expText = item?.use_cnt() + ' ' + expText;
    return m("div", {
      style: "text-align:center;"
    }, m("br", null), m("p", null, m("i", {
      class: "fas fa-level-up-alt"
    })), m("p", null, expText));
  }, async function (str) {
    return '';
  });
}
flarum.reg.add('foskym-custom-levels', 'forum/integrations/store', store);